function importDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/import/import-dialog.html'
  }
}

export { importDialog }
